/* eslint-disable prettier/prettier */
import React, { useState, createContext, useEffect } from 'react';
import { getStoreDetailByNumber } from '../api/user';

export const InventoryMajorContext = createContext<any>('');

export function InventoryMajorContextProvider(props: any) {
  const [featureFlagResponse, setfeatureFlagResponse] = useState();
  const [featureFlagDetails, setFeatureFlagDetails] = useState();
  const [searchInvFeature, setsearchInvFeature] = useState();
  const [invInfoFeature, setinvInfoFeature] = useState();
  const [invDetailsFeature, setinvDetailsFeature] = useState();
  const [idleInvAuditFeature, setidleInvAuditFeature] = useState();
  const [invActivitiesFeature, setinvActivitiesFeature] = useState();
  const [agrHistoryFeature, setagrHistoryFeature] = useState();
  const [pricetagFeature, setpricetagFeature] = useState();
  const [printEditPriceTagsFeature, setprintEditPriceTagsFeature] = useState();
  const [transferinvFeature, settransferinvFeature] = useState();
  const [newPackageFeature, setnewPackageFeature] = useState();
  const [inventoryAuditFeature, setInventoryAuditFeature] = useState();
  const [itemBeingServicedFeature, setItemBeingServicedFeature] = useState();
  const [inventoryServicingFeature, setInventoryServicingFeature] = useState();
  const [enablehyperlink, setenablehyperlink] = useState(false);
  const [recoverFeature, setRecoverFeature] = useState();
  const [invDeprConfigResponse, setInvDeprConfigResponse] = useState();
  const [serviceSummaryAry, setserviceSummaryAry] = useState<any>([]);
  const [priceOverrideLimitDetails, setPriceOverrideLimitDetails] = useState({})
  const [termOverrideLimitDetails, setTermOverrideLimitDetails] = useState({})
  const [serialNumberEditRoles, setSerialNumberEditRoles] = useState();
  const [cancelChargeOffRoles, setCancelChargeOffRoles] = useState();
  const [approveChargeOffRoles, setApproveChargeOffRoles] = useState();
  const [MXInventoryMotorCycleDetails, setMXInventoryMotorCycleDetails] = useState()
  const [MXStoreIdentifier, setMXStoreIdentifier] = useState()
  const [dateTimeLocalization, setDateTimeLocalization] = useState();
  const [countryIdentification, setCountryIdentification] = useState();
  const[zafiroInventoryService,setZafiroInventoryServiceFeature] = useState();
  

useEffect(() => {
  const fetchAndStoreDetails = async (storeNumber: string) => {
    try {
      const details = await getStoreDetailByNumber(storeNumber);
      const country = details?.response[0]?.countryAbb?.toString().toUpperCase?.();
      setCountryIdentification(country || '');
    } catch (error: any) {
      throw new Error('something went wrong' + error);
    }
  };

  const fetchStoreDetails = async () => {
    const storeDetails = sessionStorage.getItem('storeDetails');
    if (storeDetails) {
      try {
        const decoded = Buffer.from(storeDetails, 'base64').toString('utf8');
        const parsed = JSON.parse(decoded);
        const country = parsed?.country?.toString().toUpperCase?.();
        setCountryIdentification(country || '');
        return; 
      } catch (error: any) {
      throw new Error('something went wrong' + error);
    }
    }
    else{
       const storeNumber = sessionStorage.getItem('storeNumber');
        if (!storeNumber) {
          return;
        }
       await fetchAndStoreDetails(storeNumber);
    }
  };
  fetchStoreDetails();
}, []);

  return (
    <div>
      <InventoryMajorContext.Provider
        value={{
          featureFlagResponse,
          setfeatureFlagResponse,
          searchInvFeature,
          setsearchInvFeature,
          invInfoFeature,
          setinvInfoFeature,
          invDetailsFeature,
          setinvDetailsFeature,
          idleInvAuditFeature,
          setidleInvAuditFeature,
          invActivitiesFeature,
          setinvActivitiesFeature,
          agrHistoryFeature,
          setagrHistoryFeature,
          pricetagFeature,
          setpricetagFeature,
          printEditPriceTagsFeature,
          setprintEditPriceTagsFeature,
          transferinvFeature,
          settransferinvFeature,
          newPackageFeature,
          setnewPackageFeature,
          inventoryAuditFeature,
          setInventoryAuditFeature,
          itemBeingServicedFeature,
          setItemBeingServicedFeature,
          inventoryServicingFeature,
          setInventoryServicingFeature,
          enablehyperlink,
          setenablehyperlink,
          recoverFeature,
          setRecoverFeature,
          invDeprConfigResponse,
          setInvDeprConfigResponse,
          serviceSummaryAry,
          setserviceSummaryAry,
          priceOverrideLimitDetails,
          setPriceOverrideLimitDetails,
          termOverrideLimitDetails, setTermOverrideLimitDetails,
          featureFlagDetails, setFeatureFlagDetails,
          approveChargeOffRoles, setApproveChargeOffRoles,
          serialNumberEditRoles, setSerialNumberEditRoles,
          cancelChargeOffRoles, setCancelChargeOffRoles,
          MXInventoryMotorCycleDetails, setMXInventoryMotorCycleDetails,
          setMXStoreIdentifier,MXStoreIdentifier,
          dateTimeLocalization, setDateTimeLocalization,
          countryIdentification,
          zafiroInventoryService,setZafiroInventoryServiceFeature,
        }}
      >
        {props.children}
      </InventoryMajorContext.Provider>
    </div>
  );
}
